import BaseModel from './BaseModel'

export default class Feature extends BaseModel {
  // ... Feature-specific methods or overrides ...
}
